import { render, staticRenderFns } from "./vacancyInfo.vue?vue&type=template&id=6a2af2b7&"
import script from "./vacancyInfo.vue?vue&type=script&lang=js&"
export * from "./vacancyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports